import { render } from "./HomeButtons.vue?vue&type=template&id=b99cffcc&scoped=true"
import script from "./HomeButtons.vue?vue&type=script&lang=js"
export * from "./HomeButtons.vue?vue&type=script&lang=js"

import "./HomeButtons.vue?vue&type=style&index=0&id=b99cffcc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99cffcc"]])

export default __exports__